import { bff } from '@/lib/http/bff';

export type WorkflowScope = {
  scope_namespace?: string;
  scopeNamespace?: string;
  scope_key?: string;
  scopeKey?: string;
  id_scope?: number;
  id_scope_father?: number | null;
  created_at?: string;
  updated_at?: string;
  /** Last hot_stream register timestamp for this scope (nullable). */
  last_hot_stream_at?: string | null;
  /** Live record count in the hot_stream table for this scope. */
  hot_stream_count?: number;
  /** Cumulative rows archived to GCS Parquet for this scope. */
  rows_archived?: number;
  run_id?: string | number;
  workflow_run_id?: string | number;
};

export interface ScopeNamespaceCount {
  scope_namespace: string;
  count: number;
}

export interface ListScopesParams {
  limit?: number;
  cursor?: string;
  scope_namespace?: string;
  scope_namespace_prefix?: string;
  scope_key?: string;
  id_scope_father?: number;
  tenant_id?: number;
}

export const fetchWorkflowScopesApi = async (params: ListScopesParams = {}): Promise<any> =>
  bff.get<any>('/orchestrator/scopes', {
    limit: params.limit,
    cursor: params.cursor,
    scope_namespace: params.scope_namespace,
    scope_namespace_prefix: params.scope_namespace_prefix,
    scope_key: params.scope_key,
    id_scope_father: params.id_scope_father,
    tenant_id: params.tenant_id,
  });

export const fetchScopeNamespacesApi = async (tenantId?: number): Promise<{ items: ScopeNamespaceCount[] }> =>
  bff.get<{ items: ScopeNamespaceCount[] }>('/orchestrator/scopes/namespaces', {
    ...(tenantId ? { tenant_id: tenantId } : {}),
  });
